import { CALL_API } from '../middleware/ApiMiddleware';

export const FETCH_XERCE_MERGE_CODES_REQUEST = 'FETCH_XERCE_MERGE_CODES_REQUEST';
export const FETCH_XERCE_MERGE_CODES_SUCCESS = 'FETCH_XERCE_MERGE_CODES_SUCCESS';
export const FETCH_XERCE_MERGE_CODES_FAILURE = 'FETCH_XERCE_MERGE_CODES_FAILURE';
export const FETCH_MERGE_CODES_REQUEST = 'FETCH_MERGE_CODES_REQUEST';
export const FETCH_MERGE_CODES_SUCCESS = 'FETCH_MERGE_CODES_SUCCESS';
export const FETCH_MERGE_CODES_FAILURE = 'FETCH_MERGE_CODES_FAILURE';

const xerceMergeCodesBaseURL = 'xerce/config/merge-codes';
const baseURL = 'agencies/merge-codes';

// TODO: Use the unified API for xerce as well
export const fetchXERCEMergeCodes = () => ({
  [CALL_API]: {
    endpoint: xerceMergeCodesBaseURL,
    method: 'get',
    authenticated: true,
    types: [FETCH_XERCE_MERGE_CODES_REQUEST, FETCH_XERCE_MERGE_CODES_SUCCESS, FETCH_XERCE_MERGE_CODES_FAILURE],
  },
});

export const fetchMergeCodes = () => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'get',
    authenticated: true,
    types: [FETCH_MERGE_CODES_REQUEST, FETCH_MERGE_CODES_SUCCESS, FETCH_MERGE_CODES_FAILURE],
  },
});
